import { CustomFields } from "./CustomFields";

export class DocumentDialogConfiguration{
    dialogTitle: string = 'Add New File';
    descriptionFieldLabel: string = 'FILE DESCRIPTION';
    isDocumentUploadOptional:boolean = false;
    customField : CustomFields = new CustomFields();
    link: string='';
    showLink: boolean =false;
}